import { render, staticRenderFns } from "./MenuDotsHIcon.vue?vue&type=template&id=385b75b6&scoped=true&"
import script from "./MenuDotsHIcon.vue?vue&type=script&lang=js&"
export * from "./MenuDotsHIcon.vue?vue&type=script&lang=js&"
import style0 from "./MenuDotsHIcon.vue?vue&type=style&index=0&id=385b75b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b75b6",
  null
  
)

export default component.exports